module.exports = __webpack_public_path__ + "static/img/titleImg.273f842f.png";